import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Users, Trash2, Camera, Upload, Eye, CheckCircle2, AlertCircle, Phone, CreditCard } from 'lucide-react';

export function StaffMemberCard({ member, onDelete, onUploadFile, onViewFile }) {
  return (
    <div key={member.id} data-testid={`staff-member-${member.id}`} className="p-4 bg-slate-50 rounded-lg">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-11 h-11 rounded-full bg-gk-teal/10 flex items-center justify-center shrink-0 overflow-hidden">
            <Users className="w-5 h-5 text-gk-teal" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <p className="font-bold text-base">{member.name}</p>
              {member.gender && <Badge variant="outline" className="text-[10px]">{member.gender}</Badge>}
              {member.employee_id && <Badge className="bg-indigo-100 text-indigo-700 text-[10px]">EMP: {member.employee_id}</Badge>}
            </div>
            <p className="text-sm text-slate-600">{member.job_description}</p>
            <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1 text-xs text-slate-500">
              <span className="flex items-center gap-1"><CreditCard className="w-3 h-3" />{member.id_type}: {member.id_number}</span>
              {member.phone && <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{member.phone}</span>}
            </div>
            <p className="text-xs text-emerald-600 mt-1">Assigned: {member.assigned_villas.join(', ')}</p>
            <div className="flex items-center gap-2 mt-2">
              {member.photo ? (
                <Badge variant="outline" className="text-[10px] border-emerald-300 text-emerald-600"><CheckCircle2 className="w-2.5 h-2.5 mr-0.5" />Photo</Badge>
              ) : (
                <Badge variant="outline" className="text-[10px] border-amber-300 text-amber-600"><AlertCircle className="w-2.5 h-2.5 mr-0.5" />No photo</Badge>
              )}
              {member.id_document ? (
                <Badge variant="outline" className="text-[10px] border-emerald-300 text-emerald-600"><CheckCircle2 className="w-2.5 h-2.5 mr-0.5" />ID doc</Badge>
              ) : (
                <Badge variant="outline" className="text-[10px] border-amber-300 text-amber-600"><AlertCircle className="w-2.5 h-2.5 mr-0.5" />No ID doc</Badge>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 shrink-0 ml-2">
          <Button size="sm" variant="outline" onClick={() => onUploadFile(member.id, 'photo')} className="text-xs h-7">
            <Camera className="w-3 h-3 mr-1" /> {member.photo ? 'Update' : ''} Photo
          </Button>
          <Button size="sm" variant="outline" onClick={() => onUploadFile(member.id, 'id')} className="text-xs h-7">
            <Upload className="w-3 h-3 mr-1" /> {member.id_document ? 'Update' : ''} ID Doc
          </Button>
          {member.photo && (
            <Button size="sm" variant="outline" onClick={() => onViewFile(member.id, 'photo')} className="text-xs h-7 text-blue-600">
              <Eye className="w-3 h-3 mr-1" /> View Photo
            </Button>
          )}
          {member.id_document && (
            <Button size="sm" variant="outline" onClick={() => onViewFile(member.id, 'id')} className="text-xs h-7 text-blue-600">
              <Eye className="w-3 h-3 mr-1" /> View ID
            </Button>
          )}
          <Button
            data-testid={`delete-staff-${member.id}`}
            onClick={() => onDelete(member.id, member.name)}
            size="sm"
            variant="ghost"
            className="text-xs h-7 text-red-500 hover:text-red-700"
          >
            <Trash2 className="w-3 h-3 mr-1" /> Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
